import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

type Props = {
  value: number;      // persen 0–100
  label: string;      // teks bawah
  color?: string;     // warna utama
  size?: number;      // ukuran px
};

const ServiceLevelInbound: React.FC<Props> = ({
  value,
  label,
  color = "#0d833eff",
  size = 100,
}) => {
  const data = [
    { name: "value", value },
    { name: "rest", value: 100 - value },
  ];

  return (
    <div
      style={{
        // width: size,
        height: size  * 0.76,
        position: "relative",
        textAlign: "center",
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            startAngle={90}
            endAngle={-270}
            innerRadius={size * 0.24}
            outerRadius={size * 0.38}
            stroke="none"
          >
            <Cell fill={color} />
            <Cell fill="#e0e0e0" />
          </Pie>
        </PieChart>
      </ResponsiveContainer>

      {/* Text Tengah */}
      <div
        className="fs-7 mb-2"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -60%)",
          fontSize: size * 0.15,
          fontWeight: 400,
          color: "#817c7cff",
        }}
      >
        {value}%
      </div>

      {/* Label bawah */}
      <div
        className="fs-7 mt-3"
      >
        {label}
      </div>
    </div>
  );
};

export default ServiceLevelInbound;
